export default __webpack_public_path__ + "static/media/aibd.b0f9f8e5.jpg";